webpackJsonp([2,9],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(85),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// create project to send to firebase

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      switch1: false,
      switch3: false,
      title: '',
      description: '',
      isUpdating: false,
      date1: new Date().trim,
      date2: new Date().trim,
      user: {},
      users: [],
      searchText: '',
      isContact: false,
      isPending: false,
      contacts: [],
      contactNames: [],
      next: false,
      dialog: false,
      selected: null
    };
  },

  watch: {
    selectedContact: function selectedContact() {
      console.log('hola');
    },
    items: function items() {
      console.log('hi');
    },
    selected: function selected() {}
  },
  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      this.something();
      return this.users.filter(function (user) {
        return user.name.toLowerCase().match(_this.searchText.toLowerCase());
      });
    }
  },
  components: {},
  methods: {
    Cancel: function Cancel() {
      this.reset();
      this.$emit('cancel');
    },
    reset: function reset() {
      this.switch1 = false;
      this.switch3 = false;
      this.isUpdating = false;
      this.date1 = new Date().trim;
      this.date2 = new Date().trim;
      this.user = {};
      this.users = [];
      this.searchText = '';
      this.isContact = false;
      this.isPending = false;
      this.contacts = [];
      this.contactNames = [];
      this.next = false;
      this.dialog = false;
      this.selected = null;
      this.title = '';
      this.description = '';
    },
    draft: function draft() {
      console.log('at least one');
    },
    submit: function submit() {
      if (document.getElementById('title').value === '' || document.getElementById('desc').value === '' || this.switch1 === true && (this.date1 === null || this.date2 === null)) {
        console.log('ISSUE');
        return;
      }
      var members = this.selected == null ? [] : this.selected;
      var project = {
        'title': document.getElementById('title').value,
        'description': document.getElementById('desc').value,
        'dates': true,
        'endDate': this.switch1 ? this.date2 : 0,
        'startDate': this.switch1 ? this.date1 : 0,
        'members': members,
        'creator': this.$store.getters.user,
        'files': []
      };
      this.$store.dispatch('CreateProject', project);
      for (var i = 0; i < members.length; i++) {
        var timestamp = new Date().getTime();
        var user = this.filteredUsers.filter(function (user) {
          return user.id === members[i];
        });
        if (user[0] != null) {
          var notification = {
            message: this.$store.getters.user.name + ' has added you to a project: ' + project.title,
            senderID: this.$store.getters.user.id,
            senderName: this.$store.getters.user.name,
            receiverID: user[0].id,
            receiverName: user[0].name,
            read: false,
            accepted: null,
            type: 'ProjectAdd',
            timestamp: timestamp
          };
          this.$store.dispatch('sendNotification', notification);
        }
      }
      this.reset();
      this.$emit('new', project);
    },
    selectableDays: function selectableDays(date) {
      if (date >= this.date1) {
        return -1;
      }
    },
    something: function something() {
      for (var i = 0; i < this.users.length; i++) {
        if (this.contactNames.includes(this.users[i].id)) {
          this.users[i].group = 'CONNECTED';
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).get().then(function (doc) {
      var user = {
        'id': doc.id,
        'name': doc.data().name
      };
      _this2.user = user;
    }).then(function () {
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(_this2.user.id).collection('contacts').where('accepted', '==', true).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          _this2.contacts.push(doc.data());
          _this2.contactNames.push(doc.data().contactID);
        });
      }).catch(function (error) {
        console.log('Error getting documents: ', error);
      });
    });
    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts,
          'group': 'not connected'
        };
        if (user.name != null && user.id !== _this2.user.id) {
          _this2.users.push(user);
        }
      });
    });
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', [_c('v-flex', [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-card-text', [
    [_c('v-form', [_c('v-text-field', {
      attrs: {
        "label": "Title",
        "required": "",
        "id": "title"
      },
      model: {
        value: (_vm.title),
        callback: function($$v) {
          _vm.title = $$v
        },
        expression: "title"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Description",
        "required": "",
        "id": "desc"
      },
      model: {
        value: (_vm.description),
        callback: function($$v) {
          _vm.description = $$v
        },
        expression: "description"
      }
    })], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Turn on Dates"
      },
      model: {
        value: (_vm.switch1),
        callback: function($$v) {
          _vm.switch1 = $$v
        },
        expression: "switch1"
      }
    }), _vm._v(" "), _c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" Start Date ")]), _vm._v(" "), _c('v-date-picker', {
      model: {
        value: (_vm.date1),
        callback: function($$v) {
          _vm.date1 = $$v
        },
        expression: "date1"
      }
    })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch1),
        expression: "switch1"
      }],
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "120%"
      }
    }, [_vm._v(" End Date ")]), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "allowed-dates": _vm.selectableDays
      },
      model: {
        value: (_vm.date2),
        callback: function($$v) {
          _vm.date2 = $$v
        },
        expression: "date2"
      }
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Add Team Members"
      },
      model: {
        value: (_vm.switch3),
        callback: function($$v) {
          _vm.switch3 = $$v
        },
        expression: "switch3"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.switch3),
        expression: "switch3"
      }]
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "disabled": _vm.isUpdating,
        "items": _vm.filteredUsers,
        "box": "",
        "chips": "",
        "color": "blue-grey lighten-2",
        "label": "Select Team Members",
        "item-text": "name",
        "item-value": "id",
        "cache-items": "",
        "multiple": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected,
              "close": ""
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item.id)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v("\n                  " + _vm._s(data.item.name) + "\n                ")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.photoURL
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.name)
            }
          }), _vm._v(" "), _c('v-list-tile-sub-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.group)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)], 1)]
  ], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.draft
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.Cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Project_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Project_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Project_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Projectdiag_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Projectdiag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Projectdiag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: this.$store.getters.user,
      search: '',
      dialog: false,
      createDiag: false,
      show: [],
      sheet: false,
      creator: '',
      names: '',
      intervalVariable: null,
      photoURLs: '',
      projects: [],
      members: [],
      filters: [{ title: 'search' }, { title: 'filter by creator' }, { title: 'filter by time', time: '7' }]
    };
  },

  components: {
    vProject: __WEBPACK_IMPORTED_MODULE_0__Project_vue___default.a,
    vProjectDiag: __WEBPACK_IMPORTED_MODULE_1__Projectdiag_vue___default.a
  },
  computed: {
    isCurrentUser: function isCurrentUser() {
      return this.$store.getters.user.id === this.$route.params.id;
    },
    filteredProjects: function filteredProjects() {
      var _this = this;

      return this.projects.filter(function (project) {
        return project.title.toLowerCase().includes(_this.search.toLowerCase());
      });
    }
  },
  methods: {
    addProject: function addProject() {
      this.$router.push('/newProject');
    },
    deletes: function deletes(file) {
      file.projectDialog = false;
      __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(file.id).delete();
      var co = 0;
      for (var i = 0; i <= file.members.length - 1; i++) {
        __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(file.members[i]).collection('projects').get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            if (doc.data().projectID === file.id) {
              if (file.members.length === 1) {
                __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(file.members[0]).collection('projects').doc(doc.id).delete();
              } else {
                __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(file.members[co]).collection('projects').doc(doc.id).delete();
                co++;
              }
            }
          });
        });
      }
      var filteredAry = this.projects.filter(function (e) {
        return e !== file;
      });
      this.projects = filteredAry;
    },
    leave: function leave(project) {
      var _this2 = this;

      var id = project.id;
      __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.user.id).collection('projects').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          if (doc.data().projectID === id) {
            __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(_this2.user.id).collection('projects').doc(doc.id).delete();
          }
        });
      });
      __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(id).get().then(function (doc) {
        var members = doc.data().members;
        for (var i = 0; i < doc.data().members.length; i++) {
          if (doc.data().members[i] === _this2.$store.getters.user.id) {
            members.splice(i, 1);
          }
        }
        __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(id).update({ members: members });
      });
      project.projectDialog = false;
      for (var j = 0; j < this.projects.length; j++) {
        if (this.projects[j].id === id) {
          this.projects.splice(j, 1);
        }
      }
    },
    out: function out(project) {
      this.createDiag = false;
      this.intervalVariable = setInterval(this.pullFromDatabase(), 12000);
      // this.stopTimer()
    },
    stopTimer: function stopTimer() {
      clearInterval(this.intervalVariable);
    },
    dateFormat: function dateFormat(string) {
      var startYear = string.substring(0, 4);
      var startMonth = string.substring(5, 7);
      var startDay = string.substring(8, 10);
      var start = startMonth + ' / ' + startDay + ' / ' + startYear;
      this.currDate = string;
      return start;
    },
    funct: function funct(projectID) {
      this.$store.dispatch('Project', projectID);
      this.$router.push('/project/' + projectID);
    },
    showInfo: function showInfo(index) {
      this.show.splice(index, 1, !this.show[index]);
    },
    pullFromDatabase: function pullFromDatabase() {
      var _this3 = this;

      this.projects = [];
      __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var projectRef = __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(doc.data().projectID);
          projectRef.get().then(function (docu) {
            var counter = 0;
            projectRef.collection('notifications').get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (!doc.data().read.includes(_this3.$store.getters.user.id)) {
                  counter++;
                }
              });
              var project = {
                id: doc.data().projectID,
                title: docu.data().title,
                description: docu.data().description,
                startDate: docu.data().startDate,
                endDate: docu.data().endDate,
                members: docu.data().members,
                creator: docu.data().creator,
                unreadMessages: counter
              };
              counter = 0;
              _this3.members[project.id] = [];
              for (var i = 0; i < project.members.length; i++) {
                __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(project.members[i]).get().then(function (docul) {
                  var member = {
                    id: docul.data().id,
                    name: docul.data().name,
                    photoURL: docul.data().photoURL
                  };
                  _this3.members[project.id].push(member);
                });
              }
              __WEBPACK_IMPORTED_MODULE_2__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(project.creator.id).get().then(function (docu) {
                project.creatorID = project.creator.id;
                project.creator = docu.data().name;
                var oneDay = 1000 * 60 * 60 * 24;
                var date1 = new Date(project.startDate);
                var date1Ms = date1.getTime();
                var date2 = new Date(project.endDate);
                var date2Ms = date2.getTime();
                var differenceMs = date2Ms - date1Ms;
                project.difference = Math.round(differenceMs / oneDay);
                project.projectDialog = false;
                _this3.projects.push(project);
                _this3.show.push(false);
              });
            });
          });
        });
      });
    }
  },
  created: function created() {
    this.pullFromDatabase();
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  null,
  /* template */
  __webpack_require__(88),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "top": "5px"
    },
    attrs: {
      "color": "alerts",
      "relative": "",
      "fab": "",
      "top": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.createDiag = true
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "primary",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/dashboard.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "primary",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user.name.substr(0, _vm.user.name.indexOf(" "))) + "'s Project Dashboard\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search a project..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "scroll-y",
    attrs: {
      "row": "",
      "wrap": "",
      "id": "scroll-target"
    }
  }, _vm._l((_vm.filteredProjects), function(project, index) {
    return _c('v-flex', _vm._b({
      directives: [{
        name: "scroll",
        rawName: "v-scroll:#scroll-target",
        arg: "#scroll-target"
      }],
      key: project.id
    }, 'v-flex', ( _obj = {}, _obj["xs4"] = true, _obj ), false), [_c('v-card', {
      attrs: {
        "color": "grey lighten-2 pa-4"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.funct(project.id)
        }
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [(project.title.length < 30) ? _c('h1', {
      staticClass: "headline mb-0",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(project.title))]) : _vm._e(), _vm._v(" "), (project.title.length > 30) ? _c('h1', {
      staticClass: "headline mb-0",
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(project.title.substring(0, 30)) + "...")]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-badge', {
      attrs: {
        "color": "red",
        "overlap": ""
      }
    }, [(project.unreadMessages > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(project.unreadMessages))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.funct(project.id)
        }
      }
    }, [_vm._v("Open")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
      model: {
        value: (project.projectDialog),
        callback: function($$v) {
          _vm.$set(project, "projectDialog", $$v)
        },
        expression: "project.projectDialog"
      }
    }, [(_vm.$store.getters.user.id === project.creatorID) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("\n            Delete\n          ")]) : _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("Leave")]), _vm._v(" "), (_vm.$store.getters.user.id === project.creatorID) ? _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to delete the Project: " + _vm._s(project.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.deletes(project)
        }
      }
    }, [_vm._v("\n                    Delete\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          project.projectDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1) : _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to leave the Project: " + _vm._s(project.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.leave(project)
        }
      }
    }, [_vm._v("\n                    Leave\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          project.projectDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "500"
      },
      model: {
        value: (_vm.show[index]),
        callback: function($$v) {
          _vm.$set(_vm.show, index, $$v)
        },
        expression: "show[index]"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "6ex",
        "height": "6ex"
      },
      attrs: {
        "slot": "activator",
        "src": "/static/img/official_icons/info.png"
      },
      slot: "activator"
    }), _vm._v(" "), _c('v-card', [_c('v-card-title', {
      staticClass: "headline grey lighten-2",
      attrs: {
        "primary-title": ""
      }
    }, [_vm._v("\n              Details\n            ")]), _vm._v(" "), _c('v-card-text', [_c('div', {
      staticClass: "text-md-center pa-8 ma-4"
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('h1', {
      staticClass: "text-md-center"
    }, [_vm._v("\n                  " + _vm._s(project.title.substring(0).toUpperCase()) + "\n                ")])]), _vm._v(" "), _c('v-card-text', [_c('h2', [_vm._v("Description")]), _vm._v("\n                " + _vm._s(project.description) + "  \n                ")]), _vm._v(" "), (project.startDate !== 0) ? _c('v-card-text', [_c('h2', [_vm._v("Start Date")]), _vm._v("\n                " + _vm._s(_vm.dateFormat(project.startDate)) + "  \n                ")]) : _vm._e(), _vm._v(" "), (project.endDate !== 0) ? _c('v-card-text', [_c('h2', [_vm._v("End Date")]), _vm._v("\n                " + _vm._s(_vm.dateFormat(project.endDate)) + "  \n                ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('h2', [_vm._v("Members")])]), _vm._v(" "), _c('v-list', _vm._l((_vm.members[project.id]), function(member) {
      return _c('v-list-tile', {
        key: member.id + project.id + Math.random(),
        attrs: {
          "avatar": ""
        }
      }, [_c('v-list-tile-avatar', [_c('img', {
        attrs: {
          "src": member.photoURL
        }
      })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list-tile-action', [(project.creator == member.name) ? _c('div', [_vm._v("\n                        Creator\n                        "), _c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v("star")])], 1) : _vm._e()])], 1)
    }))], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.showInfo(index)
        }
      }
    }, [_vm._v("\n                Close\n              ")])], 1)], 1)], 1)], 1)], 1)])], 1)
    var _obj;
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "width": "1000"
    },
    model: {
      value: (_vm.createDiag),
      callback: function($$v) {
        _vm.createDiag = $$v
      },
      expression: "createDiag"
    }
  }, [_c('v-btn', {
    staticClass: "alerts",
    staticStyle: {
      "right": "75px",
      "bottom": "15px"
    },
    attrs: {
      "slot": "activator",
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "max-height": "8ex"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-project-diag', {
    on: {
      "cancel": function($event) {
        _vm.createDiag = false
      },
      "new": _vm.out
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "right": "150px",
      "bottom": "15px"
    },
    attrs: {
      "absolute": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/calender')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/event2.png"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "right": "225px",
      "bottom": "15px"
    },
    attrs: {
      "absolute": "",
      "fab": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/profile/' + _vm.$store.getters.user.id)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/profile.png"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-badge', {
    attrs: {
      "left": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v("6")])]), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('h3', [_vm._v("Kangaroo Valley Safari")]), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [_vm._v("Located two hours south of Sydney in the "), _c('br'), _vm._v("Southern Highlands of New South Wales, ...")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("Explore")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.a110debd56df573dae6f.js